module.exports = __webpack_public_path__ + "img/Give Control Glow.966e9f77.png";